const Cancel = () => {
  return (
    <div>Cancel</div>
  )
}

export default Cancel